import { CurrencyPipe } from "@angular/common";
import { Component, computed, effect, inject, input, output } from "@angular/core";
import { UiKitModule } from "@app/ui-kit.module";
import { FloorplanAlarmDevice } from "@domain/project/floorplan/floorplan-alarm-device";
import { FloorplanItem } from "@domain/project/floorplan/floorplan-item";
import { FloorplanSidesheetExtent } from "@domain/project/floorplan/floorplan-sidesheet-extent";
import { FloorplanAlarmDeviceDetailFormComponent } from "@project/floorplanner/floorplan-additional-notes/floorplan-alarm-device-detail-form/floorplan-alarm-device-detail-form.component";
import { FloorplanItemDetailsComponent } from "@project/floorplanner/floorplan-additional-notes/floorplan-item-details/floorplan-item-details.component";
import { FloorplanItemAttachmentsButtonComponent } from "@project/floorplanner/floorplan-item-attachments-button/floorplan-item-attachments-button.component";
import { FloorplanItemGroupComponent } from "@project/floorplanner/floorplan-item-group/floorplan-item-group.component";
import { ProductItem } from "@project/product-item";
import { ProjectStateService } from "@project/project-state.service";
import { Observable } from "rxjs";
import { take } from "rxjs/operators";

@Component({
  selector: " app-alarm-notes",
  templateUrl: "./alarm-device-notes.component.html",
  styleUrls: ["./alarm-device-notes.component.scss"],
  imports: [
    UiKitModule,
    FloorplanItemDetailsComponent,
    FloorplanItemGroupComponent,
    FloorplanItemAttachmentsButtonComponent,
    FloorplanAlarmDeviceDetailFormComponent,
  ],
  providers: [CurrencyPipe],
  standalone: true,
})
export class AlarmDeviceNotesComponent {
  private readonly projectStateService = inject(ProjectStateService);

  readonly floorplanItem = input.required<FloorplanItem>();
  readonly extent = input.required<FloorplanSidesheetExtent>();
  readonly toggleExtendedButtonClicked = output<void>();

  protected readonly alarmDevice = computed(() => this.floorplanItem() as FloorplanAlarmDevice);

  protected isDiscontinued$!: Observable<boolean>;
  protected productItems!: ProductItem[];
  protected attachments!: ProductItem[];

  constructor() {
    effect(() => {
      const alarmDevice = this.alarmDevice();
      this.isDiscontinued$ = this.projectStateService.isConfigDiscontinued(alarmDevice.config.id).pipe(take(1));
      this.productItems = this.alarmDevice().config.productIds.map((productId) => ProductItem.create(productId));
      this.attachments = this.alarmDevice().config.attachments;
    });
  }
}
